import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const boardWorkspaceIdQuery = (boardId: string) =>
	requestAndFormat(
		{
			defaultParams: {},
			gql: gql`
                query GetWorkspaceId($boardId: ID!) {
                    boards(ids: [$boardId]) {
                        id
                        workspace_id
                    }
                }`,
			skipMondayFormatting: true,
			resultKey: "boards[0].workspace_id",
			outType: "" as string,
		},
		{ boardId },
	);
